import React from 'react';
import { createRoot } from 'react-dom/client';
import 'normalize.css';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { FeishuAuthCheck } from './feishu_auth_check';

dayjs.locale('zh-cn');

const root = createRoot(document.querySelector('body')!);
root.render(<FeishuAuthCheck />);
